module.exports = __webpack_public_path__ + "img/car_26.5893e002.jpg";